import * as React from 'react';
import { useState } from 'react';
import { TransProps, useTranslation } from 'react-i18next';
import { useMediaQuery } from 'react-responsive';

import { Breakpoint, DropdownMenuTriggerTheme, IconName } from '../../../enums';
import { Status } from '../../../interfaces';
import { UseState } from '../../../types';
import { Badge } from '../../badge/badge.component';
import { DropdownMenu } from '../../dropdownMenu/dropdownMenu.component';
import { ArtworkContainer } from '../artworkContainer/artworkContainer.component';
import { OnTopSimpleMenu } from '../onTopSimpleMenu/onTopSimpleMenu.component';

import { BadgesContainer, ContentSection, Container, TopSection, MobileEditButton, InnerContainer } from './artworkBoxManage.styled';
import { ArtworkBoxManageProps } from './artworkBoxManage.types';

export const ArtworkBoxManage: React.FC<ArtworkBoxManageProps> = (props: ArtworkBoxManageProps): JSX.Element => {
  const { t }: TransProps<never> = useTranslation();
  const { badges, contextMenuPositions, artworkDetails, className }: ArtworkBoxManageProps = props;
  const [isMobileMenuOpen, setIsMobileMenuOpen]: UseState<boolean> = useState<boolean>(false);
  const isSmallMobile: boolean = useMediaQuery({ query: Breakpoint.SmallMobile });

  return (
    <>
      <Container className={className}>
        <InnerContainer>
          <TopSection>
            <BadgesContainer>
              {badges.map((badge: Status): JSX.Element => (
                <Badge
                  key={badge.label}
                  color={badge.color}
                  background={badge.background}
                  border={badge.border}
                  label={badge.label}
                />
              ))}
            </BadgesContainer>
            {!isSmallMobile && (
              <DropdownMenu
                triggerIcon={IconName.SettingsFilled}
                menuPositions={contextMenuPositions}
                triggerTheme={DropdownMenuTriggerTheme.Black}
                label={t('onarte.common.edit')}
              />
            )}
          </TopSection>
          <ContentSection>
            <ArtworkContainer artworkDetails={artworkDetails} />
          </ContentSection>
        </InnerContainer>
        <MobileEditButton onClick={(): void => setIsMobileMenuOpen(true)}>
          {t('onarte.common.edit')}
        </MobileEditButton>
        <OnTopSimpleMenu
          onIsOpenUpdate={setIsMobileMenuOpen}
          positions={contextMenuPositions}
          isOpen={isMobileMenuOpen && isSmallMobile}
        />
      </Container>
    </>
  );
};
